import { createAnalyticsTracker } from 'v2/analytics/events';

export const trackQBEvent = createAnalyticsTracker('qbAction');
